import { msg } from '@lingui/core/macro';
import { FieldMetadataMessageDescriptorDef } from './types';

export const isSecondaryField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Is secondary material',
    context: 'The display name for a dimension',
  }),
};

export const isBiologicalField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Is biological material',
    context: 'The display name for a dimension',
  }),
};

export const applicationOfCascadingPrincipleField: FieldMetadataMessageDescriptorDef =
  {
    displayName: msg({
      message: 'Application of cascading principle',
      context: 'The display name for a dimension',
    }),
  };

export const sustainableSourcingSchemeField: FieldMetadataMessageDescriptorDef =
  {
    displayName: msg({
      message: 'Sustainable sourcing scheme',
      context: 'The display name for a dimension',
    }),
  };

export const materialField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Material',
    context: 'The display name for a dimension',
  }),
};

export const orgRawMaterialField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Raw material',
    context: 'The display name for a dimension',
  }),
};

export const materialWeightField: FieldMetadataMessageDescriptorDef = {
  displayName: msg({
    message: 'Material weight',
    context: 'The weight of the material',
  }),
  externalDescription: msg({
    message: 'The weight of the material',
    context: 'Material weight',
  }),
};
